export const getDestinationBackgroundImage = (image) => {
  if (image) {
    return Array.isArray(image) ? `loc-${image[0].toLowerCase()}` : `loc-${image.toLowerCase()}`;
  }

  return null;
};
